// Company logos - these reference files in the public/assets/logos directory
// For React apps, images in the public folder can be accessed with absolute paths starting with /

export const companyLogos = {
    'Sofrecom': '/assets/logos/sofrecom.jpg',
    'GE Digital': '/assets/logos/ge.jpg',
    'Phundit': '/assets/logos/phundit.jpg',
    'RFC': '/assets/logos/rfc.jpg',
    'ATIA Club ESB': '/assets/logos/atia.jpg',
};

// School logos
export const schoolLogos = {
    "Ecole Supérieure Privée d'Ingénierie et de Technologies - ESPRIT": '/assets/schools/esprit.jpg',
    "Taher Sfar High School": '/assets/schools/taher-sfar.jpg',
};

// Project logos/icons
export const projectLogos = {
    'AIGIS': '/assets/projects/aigis.jpg',
    'Praxis AI': '/assets/projects/praxis-ai.jpg',
    'AIxCYBER2025 FinTech Eco': '/assets/projects/aix-cyber.jpg',
    'MediLearn': '/assets/projects/medilearn.jpg',
    'Dishboard': '/assets/projects/dishboard.jpg',
    'Time Conquest': '/assets/projects/time-conquest.jpg',
};

// SVG fallbacks in case images don't load
export const fallbackLogos = {
    'GE Digital': `data:image/svg+xml;base64,${btoa(`
        <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <rect width="48" height="48" rx="8" fill="#0052CC"/>
            <text x="24" y="30" text-anchor="middle" fill="white" font-family="Arial, sans-serif" font-size="14" font-weight="bold">GE</text>
        </svg>
    `)}`,

    'Phundit': `data:image/svg+xml;base64,${btoa(`
        <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <rect width="48" height="48" rx="8" fill="#2563EB"/>
            <text x="24" y="30" text-anchor="middle" fill="white" font-family="Arial, sans-serif" font-size="12" font-weight="bold">PH</text>
        </svg>
    `)}`,

    'RFC': `data:image/svg+xml;base64,${btoa(`
        <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <rect width="48" height="48" rx="8" fill="#059669"/>
            <text x="24" y="30" text-anchor="middle" fill="white" font-family="Arial, sans-serif" font-size="14" font-weight="bold">RFC</text>
        </svg>
    `)}`,

    'ATIA Club ESB': `data:image/svg+xml;base64,${btoa(`
        <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <rect width="48" height="48" rx="8" fill="#DC2626"/>
            <text x="24" y="26" text-anchor="middle" fill="white" font-family="Arial, sans-serif" font-size="10" font-weight="bold">ATIA</text>
            <text x="24" y="36" text-anchor="middle" fill="white" font-family="Arial, sans-serif" font-size="8">CLUB</text>
        </svg>
    `)}`
};